export const previousMonthQueryIdRecent = "5726177821982720";
export const lastTwoWeeksQueryIdRecent = "5738294193160192";
export const lastTwoWeeksQueryIdConversion = "5694955355897856";
export const QueryIdForKeywords = "5732929242136576";
export const performaceQueryIdBrand = "5657818854064128";
export const performaceLastRunQueryIdBrand = "5656281524207616";
export const targetVsActualQueryId = "5731076903272448";
